import React, { useContext, useState } from "react";
import { CustomDefaultTheme } from "../themes/CustomDefault";
import { Container, ThemeProvider } from "@material-ui/core";
import TmpDropdownProfileCustom, { TmpDropdownProfileItemsCustomProps } from "../components/tempo/TmpDropdownProfileCustom/TmpDropdownProfileCustom";
import TmpHeaderBaseCustom from "../components/tempo/TmpHeaderBaseCustom/TmpHeaderBaseCustom";
import { useAuthContext } from "./AuthContext";
import { useHistory } from "react-router-dom";
import Footer from "../components/Navigation/Footer";


interface IThemeContextData {
    themeName: "Default";
}

export const useThemeLoggedArearionContext = () => {
    return useContext(ThemeLoggedAreationContext);
};

export const ThemeLoggedAreationContext = React.createContext({} as IThemeContextData);

export function AppThemeLoggedAreationProvider(props: any) {

    const [themeName] = useState<"Default">("Default");
    const { userName, userCode, logout } = useAuthContext();
    let history = useHistory();
    
    const handleLogount = async () => {

        const result = await logout();

        if (result === undefined) {
            history.push("/");
        }
    }

    const itens: TmpDropdownProfileItemsCustomProps[] = [
        { handleClick: handleLogount, label: "Sair" }
    ]

    return (
        <ThemeLoggedAreationContext.Provider value={{ themeName }}>
            <ThemeProvider theme={CustomDefaultTheme} >
                <Container maxWidth="lg">

                    {/*  Header Page */}
                    <TmpHeaderBaseCustom title="Recadastramento Médico">
                        <TmpDropdownProfileCustom accountName={userCode} name={userName} itens={itens} />
                    </TmpHeaderBaseCustom>
                    {/*  Header Page */}

                    {/*  Content Page */}
                    {props.children}
                    {/* Content Page */}

                    <Footer />
                </Container>
            </ThemeProvider>
        </ThemeLoggedAreationContext.Provider>
    );

};